import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { SopService } from './sop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { getDateTimeRange } from '../tableDetails';
import { getInitalDateRangeForListData } from '../../../../global.variable';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'gtapp-sop',
  standalone: false,
  templateUrl: './sop.component.html',
  styleUrl: './sop.component.scss',
})
export class SopComponent implements OnInit, OnDestroy {
  totalRowsSOP: number = 0;
  previousSOP: number = 0;
  pageSizeSOP: number = 10;
  pageNumSOP: number = 1;
  totalPagesSOP: number = 0;
  searchParamsSOP: any;
  sortKeysSOP: any = ['-acknowledged_at'];
  dateRangeSOP: any;

  otherParamsSOP: any = {
    tableRowStyle: (rowData: any) => {
      if (!rowData?.acknowledged_at) {
        return {
          'font-weight': '600',
        };
      }
      return {};
    },
  };
  sopDataList: any = [];

  isAdmin = this.dataCheckService.isUserAdmin();
  isDispatchUser = this.dataCheckService.isDispatchUser();

  sopSubject = new Subject<void>();

  navigationEndSubscription: Subscription = new Subscription();

  urlFragmentDetails: any = {};

  tableDetailSOP: any = [];

  @ViewChild('pdfCanvas') pdfCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    private sopService: SopService,
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {}
  ngOnDestroy(): void {
    if (this.sopSubject) {
      this.sopSubject?.next();
      this.sopSubject?.complete();
    }
  }
  async ngOnInit(): Promise<void> {
    this.navigationEndSubscription = this.route.params.subscribe({
      next: (params) => {
        if (this.route.snapshot.fragment) {
          this.urlFragmentDetails = JSON.parse(
            atob(this.route.snapshot.fragment),
          );
        }
      },
    });
    if (
      this.urlFragmentDetails &&
      Object.keys(this.urlFragmentDetails)?.length
    ) {
      this.searchParamsSOP = this.urlFragmentDetails?.searchParams;
      this.updateTableDetail(this.urlFragmentDetails?.tableDetail);

      const initialDateRange = getInitalDateRangeForListData(
        this.tableDetailSOP || [],
      );
      this.dateRangeSOP = initialDateRange;
      this.onChangePaginationSOP(this.urlFragmentDetails);
    } else {
      this.updateTableDetail();
      const initialDateRange = getInitalDateRangeForListData(
        this.tableDetailSOP || [],
      );
      this.dateRangeSOP = initialDateRange;
      this.getAllSops();
    }
  }

  getAllSops() {
    this.spinnerService.show();
    let params: any = {};
    if (this.pageSizeSOP) {
      params['rows'] = this.pageSizeSOP;
    }
    if (this.previousSOP) {
      params['previous'] = this.previousSOP;
    }
    let body: any = {};
    if (this.dateRangeSOP) body.date_range = this.dateRangeSOP;
    if (this.searchParamsSOP) {
      body.ui_filters = this.searchParamsSOP;
    }

    if (this.sortKeysSOP) params.sort_key = this.sortKeysSOP;

    this.sopService
      .getSOPs(params)
      .pipe(takeUntil(this.sopSubject))
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.totalRowsSOP = response['total_size'];

          this.totalPagesSOP = Math.ceil(this.totalRowsSOP / this.pageSizeSOP);
          this.spinnerService.hide();
          this.otherParamsSOP.paginationData = {
            totalRows: this.totalRowsSOP,
            previousRows: this.previousSOP,
            rows: this.pageSizeSOP,
            pageNum: this.pageNumSOP,
            totalPages: this.totalPagesSOP,
          };

          this.sopDataList = response?.data;
          this.router.navigate([], {
            fragment: btoa(
              JSON.stringify({
                searchParams: this.searchParamsSOP,
                tableDetail: this.tableDetailSOP,
                paginationData: this.otherParamsSOP?.paginationData,
              }),
            ),
            queryParams: {},
            replaceUrl: true, // Replaces the current URL without adding a new history entry
          });
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  onChangePaginationSOP(data: any) {
    this.previousSOP = data?.paginationData?.previousRows;
    this.pageNumSOP = data?.paginationData?.pageNum;
    this.pageSizeSOP = data?.paginationData?.rows;

    this.getAllSops();

    this.otherParamsSOP.paginationData = {
      ...data?.paginationData,
    };
  }
  sortColumnSOP(sortData: any) {
    this.reseSOPVariables();
    this.sortKeysSOP = sortData?.sortList || [];
    this.getAllSops();
  }

  searchColumnSOP(searchData: any) {
    this.reseSOPVariables();
    this.dateRangeSOP = null;
    this.searchParamsSOP = searchData?.searchParams || {};

    this.getAllSops();
  }
  updateTableDetail(tableInfoFromUrl?: any) {
    let tableDetail: any = [];

    tableDetail = [
      {
        header: 'Date',
        name: 'created_at',
        datetimeObj: true,
        dateRangeKey: 'created_at',
        sortKey: 'created_at',
        default: true,
        ...getDateTimeRange(3),
        suffixNestedValue: (row: any) => {
          return `\n ${row?.created_by} \n`;
        },
        suffixStyle: { 'white-space': 'pre-line' },
      },
    ];
    if (this.isAdmin || this.isDispatchUser) {
      tableDetail.push({
        header: 'To',
        name: 'received_by',
      });
    }

    this.tableDetailSOP = tableInfoFromUrl?.length
      ? tableDetail?.map((orig: any) => {
          const preloaded = tableInfoFromUrl?.find(
            (item: any) => item?.header === orig?.header,
          );

          return {
            ...orig,
            ...preloaded,
          };
        })
      : tableDetail;
  }
  reseSOPVariables() {
    this.totalRowsSOP = 0;
    this.previousSOP = 0;
    this.pageSizeSOP = 10;
    this.pageNumSOP = 1;
    this.totalPagesSOP = 0;
    this.otherParamsSOP.paginationData = {
      totalRows: this.totalRowsSOP,
      previousRows: this.previousSOP,
      rows: this.pageSizeSOP,
      pageNum: this.pageNumSOP,
      totalPages: this.totalPagesSOP,
    };
  }
  onRowClick(data: any, template: any) {
    data.dblClicked = false;
    this.spinnerService.show('Fetching File');

    this.sopService.retrieveSOP(data?.id).subscribe((res: any) => {
      const selectedSOPInfo = res.headers.get('X-SOP_INFO');
      if (selectedSOPInfo) {
        data = { ...data, ...JSON.parse(selectedSOPInfo) };
        const itemIndex = this.sopDataList?.findIndex(
          (item: any) => item?.id == data?.id,
        );
        if (itemIndex > -1) {
          this.sopDataList[itemIndex] = data;
        }
      }

      const url = URL.createObjectURL(res?.body);
      data['pdfUrl'] = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.dialogService.open(template, { data: data }, this.viewContainerRef);
      this.spinnerService.hide();
    });
  }
}
